import { clientApi } from 'api';
import { ICountry } from 'dashboard/_redux/reducers/countries';

export const getCountries = (isServer = false) => async () => {
  const response = await clientApi.get<ICountry[]>('/countries');

  return response;
};
